import React from "react";
import { ForeignCompany, IUserApiClient } from "../clients/userApiClient"
import { useInjection } from "../di/ioc-provider"
import { TYPES } from "../di/types"
import { ConnectedApp, ForeignDossier, SortOrder } from '../clients/dossierApiClient';
import DcDataTable, { DcTableHeader, TableFilterState } from "./dcTable";
import { defaultFilter } from "../pages/DossierPage";
import { Button, Grid, TableCell, TablePagination, TableRow, Typography } from "@mui/material";
import octopusLogo from "../assets/ocotpus.jpg"
import { useTranslation } from "react-i18next";
import GeneralDialog from "./generalDialog";
import { getPageSkipTake, getSkip, sortOnFilter } from "../helpers";
import SearchField from "./searchField";
import { List } from "linqts";

export interface ISearchCompaniesViaOctopus {
    onSelected: (company: ForeignCompany) => void;
}
export const SearchCompaniesViaOctopus = (props: ISearchCompaniesViaOctopus) => {

    const [t] = useTranslation("common");
    const _userApiClient = useInjection<IUserApiClient>(TYPES.IUserClient);
    const [filterState, setFilter] = React.useState<TableFilterState>(defaultFilter);
    const [companyFilterState, setCompanyFilterState] = React.useState<TableFilterState>(defaultFilter);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [foreignDossierId, setForeignDossierId] = React.useState<number | undefined>(undefined);
    const [foreignDossiers, setForeigDossiers] = React.useState<ForeignDossier[]>([]);
    const [foreignCompanies,setForeignCompanies] = React.useState<ForeignCompany[]>([])
    const [loading,setLoading] = React.useState<boolean>(false);
    const headers = [
        { name: t("general.companyName"), id: "description" },
        { name: t("general.vat"), id: "vat" },
        ,
    ] as DcTableHeader[]
    const companiesHeaders = [
        { name: t("general.companyName"), id: "name" },
        { name: t("general.companyEmail"), id: "email" },
    ] as DcTableHeader[]
    React.useEffect(() => {
        if(foreignDossierId != undefined){
            setLoading(true);
            _userApiClient.getCompanies({
                skip: companyFilterState.skip,
                take: companyFilterState.take,
                sortColumn: companyFilterState.sortColumn,
                sortOrder: companyFilterState.sortOrder,
                payload: { search: "", app: ConnectedApp.Octopus,dossierId :foreignDossierId }
            }).then((res) => {
                setForeignCompanies(res.data.data);
            }).finally(() => {
                setLoading(false);
            })
        }
    }, [foreignDossierId])

    React.useEffect(() => {
        if(openDialog){
            setLoading(true);
            _userApiClient.getForeignDossiers({
                skip: filterState.skip,
                take: filterState.take,
                sortColumn: filterState.sortColumn,
                sortOrder: filterState.sortOrder,
                payload: { search: filterState.search, app: ConnectedApp.Octopus }
            }).then((res) => {
              setForeigDossiers(res.data.data);
            }).finally(() => {
                setLoading(false)
            })
        }
    },[openDialog]);
    const filteredCompanies = React.useMemo(() => {
        return new List(foreignCompanies).Where(w=>w.vat?.indexOf(companyFilterState.search)!=-1 || w.name?.toLowerCase().indexOf(companyFilterState.search?.toLowerCase())!=-1)
    }, [companyFilterState, foreignCompanies])

    const limitedCompanies = React.useMemo(() => {
        return filteredCompanies.Skip(companyFilterState.skip).Take(companyFilterState.take).ToArray();
    },[filteredCompanies])
    const onChangePage = (page: number) => {
        var skip = getSkip(page, companyFilterState.take);
        var copy = { ...companyFilterState };
        copy.skip = skip;
        setCompanyFilterState(copy);
    }
    return <>
        <Button style={{ color: "#0951a4" }} onClick={() => { setOpenDialog(true) }} startIcon={<img src={octopusLogo}></img>}>{t("general.searchCompanyWithOctopus")}</Button>
        <GeneralDialog isLoading={loading} open={openDialog} onClose={() => { setOpenDialog(false) }}>
            
            <Grid container spacing={2} style={{ paddingBottom: "4px" }}>
                <Grid item><img src={octopusLogo}></img></Grid>
                <Grid item style={{
                    position: "relative",
                    top: "12px"
                }}> <Typography color={"#0951a4"}>{foreignDossierId == undefined ? t("general.searchDossierWithOctopus") : t("general.searchCompanyWithOctopus")}</Typography></Grid>
            </Grid>
            {foreignDossierId == undefined? <>
                <DcDataTable
                    headers={headers}
                    onFilterClicked={(el) => { setFilter(sortOnFilter(filterState, el)) }}
                    filters={filterState}>
                    {foreignDossiers.map((el) => {
                        return <>
                            <TableRow className="clickable" key={el.id} hover onClick={() => { setForeignDossierId(el.id) }}>
                                <TableCell>{el.description}</TableCell>
                                <TableCell>{el.vat}</TableCell>
                            </TableRow>
                        </>
                    })}
                </DcDataTable></> :
                 <>
                    <SearchField
                        className="full-width"
                        onChange={() => { }}
                        id="search-departments"
                        debouncedWaitTime={500}
                        label={t("general.search")}
                        onDebouncedSearch={(val) => {
                            var copy = { ...companyFilterState };
                            copy.search = val;
                            setCompanyFilterState(copy);
                        }} />
                    <DcDataTable
                        headers={companiesHeaders}
                        onFilterClicked={(el) => { setCompanyFilterState(sortOnFilter(companyFilterState, el)) }}
                        filters={companyFilterState}>
                        {limitedCompanies.map((el) => {
                            return <>
                                <TableRow className="clickable" key={el.id} hover onClick={() => {props.onSelected(el); setOpenDialog(false) }}>
                                    <TableCell>{el.name}</TableCell>
                                    <TableCell>{el.email}</TableCell>
                                </TableRow>
                            </>
                        })}
                    </DcDataTable>
                    <TablePagination
                        labelRowsPerPage={t("general.rowsPerPage")}
                        style={{ marginLeft: "auto", color: "black!important" }}
                        rowsPerPageOptions={[20,50,100]}
                        component="div"
                        count={filteredCompanies.Count()}
                        rowsPerPage={companyFilterState.take}
                        page={getPageSkipTake(companyFilterState.skip, companyFilterState.take)}
                        onPageChange={(event, page) => { onChangePage(page) }}
                        onRowsPerPageChange={(event) => {
                            var copy = { ...companyFilterState };
                            copy.take = Number.parseInt(event.target.value);
                            setCompanyFilterState(copy);
                        }}
                    />
                 </>
                 }
            
        </GeneralDialog>
    </>
}